import script from "./NetworkAccessHint.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkAccessHint.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__